import { INCOME_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  getIncomeLoading: false,
  getIncomeSuccess: false,
  getIncomeFailure: false,
  getIncomeError: null,
  deleteIncomeLoading: false,
  deleteIncomeSuccess: false,
  deleteIncomeFailure: false,
  deleteIncomeError: null,
  addIncomeLoading: false,
  addIncomeSuccess: false,
  addIncomeFailure: false,
  addIncomeError: null,
  IncomeList: []
}

export const incomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INCOME_REQUEST.GET_INCOME_REQUEST:
      return {
        ...state,
        getIncomeLoading: true,
        getIncomeSuccess: false,
        getIncomeFailure: false,
        getIncomeError: null
      }
    case INCOME_REQUEST.GET_INCOME_SUCCESS:
      return {
        ...state,
        getIncomeLoading: false,
        getIncomeSuccess: true,
        getIncomeFailure: false,
        getIncomeError: null,
        IncomeList: action.payload
      }
    case INCOME_REQUEST.GET_INCOME_FAILURE:
      return {
        ...state,
        getIncomeLoading: false,
        getIncomeSuccess: false,
        getIncomeFailure: true,
        getIncomeError: action.payload
      }
    case INCOME_REQUEST.ADD_INCOME_REQUEST:
      return {
        ...state,
        addIncomeLoading: true,
        addIncomeSuccess: false,
        addIncomeFailure: false,
        addIncomeError: null
      }
    case INCOME_REQUEST.ADD_INCOME_SUCCESS:
      return {
        ...state,
        addIncomeLoading: false,
        addIncomeSuccess: true,
        addIncomeFailure: false,
        addIncomeError: null,
      }
    case INCOME_REQUEST.ADD_INCOME_FAILURE:
      return {
        ...state,
        addIncomeLoading: false,
        addIncomeSuccess: false,
        addIncomeFailure: true,
        addIncomeError: action.payload
      }
    case INCOME_REQUEST.DELETE_INCOME_REQUEST:
      return {
        ...state,
        deleteIncomeLoading: true,
        deleteIncomeSuccess: false,
        deleteIncomeFailure: false,
        deleteIncomeError: null
      }
    case INCOME_REQUEST.DELETE_INCOME_SUCCESS:
      let income_list = state.IncomeList;
      for (let i = 0; i < state.IncomeList.length; i++) {
        if (income_list[i].incomeId === action.payload) {
          income_list.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteIncomeLoading: false,
        deleteIncomeSuccess: true,
        deleteIncomeFailure: false,
        deleteIncomeError: null,
        IncomeList: income_list
      }
    case INCOME_REQUEST.DELETE_INCOME_FAILURE:
      return {
        ...state,
        deleteIncomeLoading: false,
        deleteIncomeSuccess: false,
        deleteIncomeFailure: true,
        deleteIncomeError: action.payload
      }
    default:
      return state;
  }
}